import { matchPath } from 'react-router-dom';
import lazyWithPreload from './lib/lazyWithPreload';
import { COMPARE_PAGES } from './content/compare';

// The prerendered pages (scripts/prerender.mjs), each code-split, so a route
// downloads only what it renders: a legal page does not carry the blog, and the
// homepage carries neither.
//
// Their HTML is already painted when the app starts, so src/index.js loads the
// current route's code with preloadRoute before React's first render, and the
// page renders without suspending. Reached by in-app navigation instead, they
// load through Suspense like any other code-split page.
export const BlogNavbar = lazyWithPreload(() => import('./components/BlogNavbar'));
export const BlogPage = lazyWithPreload(() => import('./pages/BlogPage'));
export const BlogPostPage = lazyWithPreload(() => import('./pages/BlogPostPage'));
export const TermsPage = lazyWithPreload(() => import('./pages/TermsPage'));
export const PrivacyPage = lazyWithPreload(() => import('./pages/PrivacyPage'));
export const ClientTermsPage = lazyWithPreload(() => import('./pages/ClientTermsPage'));
export const ClientPrivacyPage = lazyWithPreload(() => import('./pages/ClientPrivacyPage'));
export const ContractorTermsPage = lazyWithPreload(() => import('./pages/ContractorTermsPage'));
export const ContractorPrivacyPage = lazyWithPreload(() => import('./pages/ContractorPrivacyPage'));
export const ComparePage = lazyWithPreload(() => import('./pages/ComparePage'));
export const PreLaunchPage = lazyWithPreload(() => import('./pages/PreLaunchPage'));
export const PerksPage = lazyWithPreload(() => import('./pages/PerksPage'));
export const PrepPage = lazyWithPreload(() => import('./pages/PrepPage'));
export const GetPrepPage = lazyWithPreload(() => import('./pages/GetPrepPage'));

// Each prerendered path, as App.js routes it, and what it renders there. A
// prerendered route missing here still works, but React replaces its painted page
// with the loading fallback until its code arrives.
const ROUTES = [
  ['/', [PreLaunchPage]],
  ['/blog', [BlogNavbar, BlogPage]],
  ['/blog/:slug', [BlogNavbar, BlogPostPage]],
  ['/terms', [TermsPage]],
  ['/privacy', [PrivacyPage]],
  ['/client-terms', [ClientTermsPage]],
  ['/client-privacy', [ClientPrivacyPage]],
  ['/contractor-terms', [ContractorTermsPage]],
  ['/contractor-privacy', [ContractorPrivacyPage]],
  ...COMPARE_PAGES.map((page) => [page.ROUTE, [BlogNavbar, ComparePage]]),
  ['/perks', [PerksPage]],
  ['/prep', [PrepPage]],
  ['/get-prep', [GetPrepPage]],
];

// Resolves once the code for `pathname` has loaded, if it is a prerendered route.
// Never rejects: a chunk that fails to load here is tried again through Suspense.
export const preloadRoute = (pathname) => {
  const route = ROUTES.find(([path]) => matchPath(path, pathname));
  return Promise.all((route ? route[1] : []).map((c) => c.preload())).catch(() => {});
};
